import React from "react";

/**
 * Eyebrow + H2 + optional lead paragraph, per design-system/landing.md §4.
 * `align` controls both text alignment and whether the lead paragraph is
 * centred (max-width prose) or left-aligned (full width of the section).
 */
export default function SectionHeading({ eyebrow, title, lead, align = "center" }) {
  const isCentered = align === "center";

  return (
    <div className={isCentered ? "mx-auto max-w-[68ch] text-center" : "max-w-[68ch]"}>
      {eyebrow && (
        <p className="mb-3 font-mono text-xs uppercase tracking-widest text-rf-accent">
          {eyebrow}
        </p>
      )}
      <h2 className="text-[clamp(2rem,3vw+1rem,3rem)] font-bold leading-[1.15] tracking-tight text-rf-text-primary">
        {title}
      </h2>
      {lead && (
        <p className="mt-4 text-lg leading-relaxed text-rf-text-secondary">{lead}</p>
      )}
    </div>
  );
}
